import "../App.css";
import { Typography, Box, Button, Card, CardContent, CardActions } from "@mui/material";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { theme } from "../services/Theme";
import useWindowDimensions from "../services/useWindowDimensions";

function ServiceCard({
  serviceImage,
  serviceTitle,
  serviceKey,
  serviceDescription,
  openContactForm,
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const { width } = useWindowDimensions();
  const isMobile = width < 600;
  const hasImage = Boolean(serviceImage);

  useEffect(() => {
    setImageLoaded(false);
  }, [serviceImage]);

  const ctaButtonSx = {
    color: theme.palette.text.light,
    borderColor: "rgba(218, 218, 218, 0.45)",
    "&:hover": {
      borderColor: theme.palette.text.light,
      backgroundColor: "rgba(218, 218, 218, 0.08)",
    },
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: "580px",
        margin: "0 auto",
        borderRadius: 2,
        backgroundColor: "rgba(32,32,32,1)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "1 / 1",
          overflow: "hidden",
        }}
      >
      {hasImage && (
        <img
          src={serviceImage}
          alt={serviceTitle}
          onLoad={() => setImageLoaded(true)}
          loading="lazy"
          decoding="async"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            opacity: imageLoaded ? 1 : 0,
            transition: "opacity 0.5s ease-out",
          }}
        />
      )}

      {(!hasImage || !imageLoaded) && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(120deg, rgba(30,30,30,1) 0%, rgba(52,52,52,1) 45%, rgba(30,30,30,1) 100%)",
            backgroundSize: "220% 100%",
            animation: "serviceImageShimmer 1.4s ease-in-out infinite",
            zIndex: 1,
          }}
        />
      )}

      </Box>

      <CardContent sx={{ flexGrow: 1, px: { xs: 2, sm: 2.5 }, pt: 2, pb: 1 }}>
        <Typography
          color={theme.palette.text.light}
          variant="h5"
          sx={{
            fontSize: { xs: "1.15rem", sm: "1.4rem" },
            lineHeight: 1.2,
            mb: 1,
          }}
        >
          {serviceTitle}
        </Typography>
        <Typography
          component="div"
          color={theme.palette.text.light}
          variant="body2"
          sx={{
            fontSize: { xs: "0.9rem", sm: "0.95rem" },
            lineHeight: 1.55,
            opacity: 0.92,
          }}
        >
          {serviceDescription}
        </Typography>
      </CardContent>

      <CardActions sx={{ px: { xs: 2, sm: 2.5 }, pt: 0, pb: 2 }}>
        {isMobile ? (
          <Button
            variant="outlined"
            color="secondary"
            component={Link}
            to="/contact"
            state={{ preselectedService: serviceKey }}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            sx={ctaButtonSx}
            fullWidth
          >
            Request a Quote
          </Button>
        ) : (
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => openContactForm(serviceKey)}
            sx={ctaButtonSx}
            fullWidth
          >
            Request a Quote
          </Button>
        )}
      </CardActions>

      <style>
        {`@keyframes serviceImageShimmer {
            0% { background-position: 100% 0; }
            100% { background-position: -100% 0; }
          }`}
      </style>
    </Card>
  );
}

export default ServiceCard;
